import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router.js'
import store from './store'
import i18n from './i18n'

Vue.config.productionTip = false
Vue.prototype.$i18n = i18n

Vue.mixin({
  computed: {
    currentLocale() {
      return this.$i18n.state.locale
    }
  },
  methods: {
    t(key, params) {
      return this.$i18n.t(key, params)
    },
    formatDate(value) {
      return this.$i18n.formatDate(value)
    }
  }
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
